import React from 'react'
import { Button, Layout, Dropdown } from 'antd'
import account from '../assets/account.svg'
import MainMenu from './MainMenu'
import Logo from '../assets/hockey-logo-1.png'
import Insta from '../assets/insta.svg'
import Fb from '../assets/fb.svg'
import Twitter from '../assets/twitter.svg'
import YouTube from '../assets/youtube.svg'
import { Footer } from 'antd/es/layout/layout'
import { useLocation, useNavigate } from 'react-router-dom'
import { landingSignup } from '../config/constants'
import LoginDropdown from './LoginDropdown'
import { useDispatch } from 'react-redux'
import { removeLeague } from '../redux'
// import { isAuthenticated } from '../functions/auth'

import LogoSport from '../assets/Logo.svg'
import Title from '../assets/title.png'

const VerticalLayout = ({ children, active }) => {
  const { Sider, Content } = Layout
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const logout = () => {
    navigate('/')
    dispatch(removeLeague())
    // location.reload()
    localStorage.clear()
  }
  // const login = () => navigate('/login')

  const navigateTo = (route) => navigate(route)

  const items = [
    {
      key: '1',
      label: <p onClick={() => navigateTo('/edit-profile')}>Profile</p>,
    },
    {
      key: '2',
      label: <p onClick={logout}>Logout</p>,
    },
  ]

  return (
    <div className='v-layout'>
      <Layout>
        <Sider
          trigger={null}
          collapsible
          width={256}
          style={{
            overflow: 'auto',
            height: '100vh',
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
            background: 'var(--sidebar)',
            boxShadow: 'box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px',
          }}
        >
          <div className='company-logo'>
            <img src={Logo} alt='image' />
          </div>
          <MainMenu active={active} />
          <div className='sider-bottom'>
            <div className='icons'>
              <img src={Insta} />
              <img src={Fb} />
              <img src={Twitter} />
              <img src={YouTube} />
            </div>
            <div className='caution'>
              <p style={{ lineHeight: 1.5 }}>Jobs • Responsible Play</p>
            </div>
          </div>
        </Sider>
        <Layout className='site-layout' style={{ marginLeft: 256 }}>
          <div className='mainHeader'>
            {pathname === '/fantasy-league' || pathname === '/' ? (
              <div className='side_logo'>
                <img src={LogoSport} alt='logo' className='logo' />
                <img src={Title} alt='samsports' className='title' />
              </div>
            ) : (
              <div />
            )}

            {localStorage.getItem('token') ? (
              <div className='auth-buttons'>
                <Dropdown
                  menu={{
                    items,
                  }}
                >
                  <img
                    src={account}
                    style={{
                      cursor: 'pointer',
                    }}
                  />
                </Dropdown>
              </div>
            ) : (
              <div className='auth-buttons'>
                {/* <Button type='default' onClick={login}>
                  Login
                </Button> */}
                <LoginDropdown loginFromNavbar />
                <Button type='primary' onClick={landingSignup}>
                  Sign Up
                </Button>
              </div>
            )}
          </div>
          <Content className='main-content'>{children}</Content>
          <Footer className='mainFooter'>
            <p>© Sam Sports, Inc. All rights reserved.</p>

            {/* <a href='https://sportsdata.io' target='_blank' rel='noreferrer'>
              <img
                style={{ height: '50px', width: 'auto' }}
                src='https://sportsdata.io/assets/images/badges/sportsdataio_light_ss_300.png'
                alt='Powered by SportsDataIO'
              />
            </a> */}
          </Footer>
        </Layout>
      </Layout>
    </div>
  )
}

export default VerticalLayout
